export class InvalidAPIKeyError extends Error {
  constructor (message?: string) {
    super(message || 'Invalid Woorank Public API key');
    this.name = 'InvalidAPIKeyError';
  }
}

function throwOnInvalidCredentials (socketgenJsonResult: any) {
  if (socketgenJsonResult?.code === 'INVALID_CREDENTIALS') {
    throw new InvalidAPIKeyError();
  }
}

const BASE = window.location.origin;
export async function fetchReview (reviewUrl: string, apiKey: string) {
  console.log({ event: 'fetch-review', reviewUrl, apiKey });
  if (!apiKey) {
    return;
  }
  const apiUrl = new URL('/shopify/woorank-api/reviews', BASE);
  apiUrl.searchParams.append('url', reviewUrl);
  const reviewResult = await window.fetch(apiUrl.toString(), {
    headers: {
      'X-API-KEY': apiKey
    }
  });
  if (reviewResult.status === 404) {
    return null;
  }
  const result = await reviewResult.json();
  throwOnInvalidCredentials(result);
  if (reviewResult.status === 200) {
    return result;
  }
}

// todo: add response type here
export async function generateReview (reviewUrl: string, apiKey: string) {
  console.log({ event: 'generate-review', reviewUrl, apiKey });
  if (!apiKey) {
    return;
  }
  const apiUrl = new URL('/shopify/woorank-api/reviews', BASE);
  const reviewResult = await window.fetch(apiUrl.toString(), {
    method: 'POST',
    body: JSON.stringify({ url: reviewUrl }),
    headers: {
      'X-API-KEY': apiKey,
      'Content-Type': 'application/json'
    }
  });
  if (reviewResult.status === 400) {
    throw new Error('start review generation failed');
  }
  const result = await reviewResult.json();
  throwOnInvalidCredentials(result);
  if (reviewResult.status === 200) {
    return reviewResult.json();
  }
}

export async function generateReport (url: string, apiKey: string) {
  console.log({ event: 'generate-report', url, apiKey });
  if (!apiKey) {
    return;
  }
  const apiUrl = new URL('/shopify/woorank-api/reports', BASE);
  const reviewResult = await window.fetch(apiUrl.toString(), {
    method: 'POST',
    body: JSON.stringify({ url }),
    headers: {
      'X-API-KEY': apiKey,
      'Content-Type': 'application/json'
    }
  });
  const result = await reviewResult.json();
  throwOnInvalidCredentials(result);
  if (reviewResult.status === 200) {
    return result;
  }
}

export async function createProject (url: string, apiKey: string) {
  console.log({ event: 'generate-project', url, apiKey });
  if (!apiKey) {
    return;
  }
  const apiUrl = new URL('/shopify/woorank-api/projects-internal', BASE);
  const reviewResult = await window.fetch(apiUrl.toString(), {
    method: 'POST',
    body: JSON.stringify({ url, cwvEnabled: true }),
    headers: {
      'X-API-KEY': apiKey,
      'Content-Type': 'application/json'
    }
  });
  if (reviewResult.status === 400 && reviewResult.body) {
    const res = await reviewResult.json();
    return res;
  }
  const result = await reviewResult.json();
  throwOnInvalidCredentials(result);
  if (reviewResult.status === 200) {
    return result;
  }
}

export async function getProject (url: string, apiKey: string) {
  console.log({ event: 'fetch-project', url, apiKey });
  if (!apiKey) {
    return;
  }
  const apiUrl = new URL(
    '/shopify/woorank-api/projects-internal/' + encodeURIComponent(url),
    BASE
  );
  const projectResult = await window.fetch(apiUrl.toString(), {
    headers: {
      'X-API-KEY': apiKey
    }
  });
  if (projectResult.status === 404) {
    return null;
  }
  const result = await projectResult.json();
  if (projectResult.status === 200) {
    return result;
  }
  throwOnInvalidCredentials(result);
  return null;
}

export async function getProjectPages (
  host: string,
  apiKey: string,
  limit: number = 25
) {
  console.log({ event: 'fetch-project-pages', host, apiKey });
  if (!apiKey) {
    return;
  }
  const apiUrl = new URL('/shopify/woorank-api/reports/', BASE);
  apiUrl.searchParams.append('host', host);
  apiUrl.searchParams.append('limit', limit.toString());
  const reportsResult = await window.fetch(apiUrl.toString(), {
    headers: {
      'X-API-KEY': apiKey
    }
  });
  const result = await reportsResult.json();
  throwOnInvalidCredentials(result);
  if (reportsResult.status === 200) {
    return result;
  }
}
export async function getProjectPage (url: string, apiKey: string) {
  console.log({ event: 'fetch-project-page', url, apiKey });
  if (!apiKey) {
    return;
  }
  const apiUrl = new URL(
    '/shopify/woorank-api/reports/' + encodeURIComponent(url),
    BASE
  );
  const reportResult = await window.fetch(apiUrl.toString(), {
    headers: {
      'X-API-KEY': apiKey
    }
  });
  const result = await reportResult.json();
  throwOnInvalidCredentials(result);
  if (reportResult.status === 200) {
    return result;
  }
}

export async function getOrCreateProject (url: string, apiKey: string) {
  const project = await getProject(url, apiKey);
  if (project) {
    return project;
  }
  const generationDetails = await createProject(url, apiKey);
  return generationDetails;
}
export async function getMetrics (url: string, apiKey: string) {
  console.log({ event: 'fetch-project-page', url, apiKey });
  if (!apiKey) {
    return;
  }
  const apiUrl = new URL('/shopify/woorank-api/metrics/', BASE);
  apiUrl.searchParams.append('url', url);
  const reportResult = await window.fetch(apiUrl.toString(), {
    headers: {
      'X-API-KEY': apiKey
    }
  });
  const result = await reportResult.json();
  throwOnInvalidCredentials(result);
  if (reportResult.status === 200) {
    return result;
  }
}
